import React from "react";
import {
  PortalContainer,
  PortalSection,
} from "../../portal/PortalCard";
import MyInfo from "./MyInfo";
import ComissionRule from "./ComissionRule";
import Metric from "./Metric";
import BalanceLog from "./BalanceLog";

const UnnamedComponent = (props) => (
  <PortalContainer>
    <PortalSection title="Informasi Afiliator" subtitle="Kelola akun afiliasi dan kode referral Anda." action={<ComissionRule />}>
      <MyInfo />
    </PortalSection>
    <PortalSection title="Statistik" subtitle="Ringkasan performa afiliasi Anda.">
      <Metric />
    </PortalSection>
    <PortalSection title="Jurnal Kas" subtitle="Riwayat transaksi komisi Anda.">
      <BalanceLog />
    </PortalSection>
  </PortalContainer>
);
export default UnnamedComponent;
